/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLanguageTranslations200ResponseItemsInnerName } from './GetLanguageTranslations200ResponseItemsInnerName';
import {
    GetLanguageTranslations200ResponseItemsInnerNameFromJSON,
    GetLanguageTranslations200ResponseItemsInnerNameFromJSONTyped,
    GetLanguageTranslations200ResponseItemsInnerNameToJSON,
    GetLanguageTranslations200ResponseItemsInnerNameToJSONTyped,
} from './GetLanguageTranslations200ResponseItemsInnerName';

/**
 * 
 * @export
 * @interface GetLanguageTranslations200ResponseItemsInner
 */
export interface GetLanguageTranslations200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLanguageTranslations200ResponseItemsInner
     */
    organizationItemId: string;
    /**
     * 
     * @type {string}
     * @memberof GetLanguageTranslations200ResponseItemsInner
     */
    type: GetLanguageTranslations200ResponseItemsInnerTypeEnum;
    /**
     * 
     * @type {GetLanguageTranslations200ResponseItemsInnerName}
     * @memberof GetLanguageTranslations200ResponseItemsInner
     */
    name?: GetLanguageTranslations200ResponseItemsInnerName;
    /**
     * 
     * @type {GetLanguageTranslations200ResponseItemsInnerName}
     * @memberof GetLanguageTranslations200ResponseItemsInner
     */
    description?: GetLanguageTranslations200ResponseItemsInnerName;
}


/**
 * @export
 */
export const GetLanguageTranslations200ResponseItemsInnerTypeEnum = {
    Product: 'product',
    Combo: 'combo',
    Modifier: 'modifier',
    ModifierGroup: 'modifierGroup',
    CatalogCategory: 'catalogCategory',
    ComboCategory: 'comboCategory'
} as const;
export type GetLanguageTranslations200ResponseItemsInnerTypeEnum = typeof GetLanguageTranslations200ResponseItemsInnerTypeEnum[keyof typeof GetLanguageTranslations200ResponseItemsInnerTypeEnum];


/**
 * Check if a given object implements the GetLanguageTranslations200ResponseItemsInner interface.
 */
export function instanceOfGetLanguageTranslations200ResponseItemsInner(value: object): value is GetLanguageTranslations200ResponseItemsInner {
    if (!('organizationItemId' in value) || value['organizationItemId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetLanguageTranslations200ResponseItemsInnerFromJSON(json: any): GetLanguageTranslations200ResponseItemsInner {
    return GetLanguageTranslations200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetLanguageTranslations200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLanguageTranslations200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationItemId': json['organizationItemId'],
        'type': json['type'],
        'name': json['name'] == null ? undefined : GetLanguageTranslations200ResponseItemsInnerNameFromJSON(json['name']),
        'description': json['description'] == null ? undefined : GetLanguageTranslations200ResponseItemsInnerNameFromJSON(json['description']),
    };
}

export function GetLanguageTranslations200ResponseItemsInnerToJSON(json: any): GetLanguageTranslations200ResponseItemsInner {
    return GetLanguageTranslations200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetLanguageTranslations200ResponseItemsInnerToJSONTyped(value?: GetLanguageTranslations200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationItemId': value['organizationItemId'],
        'type': value['type'],
        'name': GetLanguageTranslations200ResponseItemsInnerNameToJSON(value['name']),
        'description': GetLanguageTranslations200ResponseItemsInnerNameToJSON(value['description']),
    };
}

